import { render, staticRenderFns } from "./detail_supplyChain.vue?vue&type=template&id=0b85c4c5&scoped=true&"
import script from "./detail_supplyChain.vue?vue&type=script&lang=js&"
export * from "./detail_supplyChain.vue?vue&type=script&lang=js&"
import style0 from "./detail_supplyChain.vue?vue&type=style&index=0&id=0b85c4c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85c4c5",
  null
  
)

export default component.exports